import React from 'react';
import { bool, string, func } from 'prop-types';
import { IonIcon } from '@ionic/react';
import Modal from 'react-modal';
import cn from 'classnames';
import { t } from 'i18next';
import { closeOutline } from 'ionicons/icons';

import styles from './styles.module.scss';

function CustomModal({
  children,
  className,
  onRequestClose,
  overlayClassName,
  longContentClass,
  modalClassName,
  closeButtonClassName,
  iconCloseClassName,
  shouldReturnFocusAfterClose,
  hideCloseButton,
  disableCloseButton,
  shouldCloseOnOverlayClick,
  onAfterClose,
  ...props
}) {
  return (
    <Modal
      onAfterClose={onAfterClose}
      onRequestClose={onRequestClose}
      className={cn(styles.modal, modalClassName, {
        [styles.longContent]: longContentClass
      })}
      overlayClassName={cn('column center', styles.modalOverlay, overlayClassName)}
      shouldReturnFocusAfterClose={shouldReturnFocusAfterClose}
      bodyOpenClassName={styles.body}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      {...props}>
      <div className={cn(styles.modalContainer, className)} role="dialog" tabIndex="-1">
        {!hideCloseButton && (
          <button
            id="button-close-modal"
            type="button"
            className={cn(styles.closeButton, closeButtonClassName)}
            onClick={onRequestClose}
            disabled={disableCloseButton}
            aria-label={t('CustomModal:closeButton')}>
            <IonIcon icon={closeOutline} className={`${styles.iconClose} ${iconCloseClassName}`} />
          </button>
        )}
        {children}
      </div>
    </Modal>
  );
}

CustomModal.defaultProps = {
  iconCloseClassName: '',
  shouldCloseOnOverlayClick: false,
  shouldReturnFocusAfterClose: false
};

CustomModal.propTypes = {
  onRequestClose: func.isRequired,
  className: string,
  closeButtonClassName: string,
  disableCloseButton: bool,
  hideCloseButton: bool,
  iconCloseClassName: string,
  longContentClass: bool,
  modalClassName: string,
  overlayClassName: string,
  shouldCloseOnOverlayClick: bool,
  shouldReturnFocusAfterClose: bool,
  onAfterClose: func
};

export default CustomModal;
